module.exports = __webpack_public_path__ + "img/men.a6be678e.png";